import React from "react";
import { css } from "@emotion/react";
import { useAppDispatch, useAppSelector } from "main/javascripts/store";
import { cruiseSelector, setIsCruiseImageModalDisplayed } from "../cruiseSlice";
import { space } from "main/javascripts/styles/base/spaceStyle";
import { moreThanBreakpoint } from "main/javascripts/styles/base/responsiveStyle";
import { ImageList } from "main/javascripts/components/spot/ImageList";

export const CruiseImageList: React.FC = (): React.ReactElement => {
  const appDispatch = useAppDispatch();

  const cruise = useAppSelector(cruiseSelector);
  const images = cruise?.vessel?.vesselImages || [];
  const imageData = images.map((image) => {
    return {
      url: image.imageUrl,
      isDefault: false,
    };
  });

  const imageListStyles = { exBlockStyle: imageListBlockStyle };

  if (imageData.length === 0) {
    return null;
  }

  const onImageListClick = () => {
    appDispatch(setIsCruiseImageModalDisplayed(true));
  };

  return (
    <div css={imageBlockStyle}>
      <ImageList
        images={imageData}
        styles={imageListStyles}
        onClick={onImageListClick}
      />
    </div>
  );
};

const imageBlockStyle = css`
  margin: 0 0 ${space.atom2x} 0;
  cursor: pointer;

  ${moreThanBreakpoint("desktop")} {
    margin: 0 0 ${space.atom4x};
  }
`;
const imageListBlockStyle = css`
  padding: 0 0 ${space.atom};
`;
